import React from "react";

export const About = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img
              src="header.jpg"
              style={{ borderRadius: "50%" }}
              className="img-responsive"
              alt="Hakkımızda"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Hakkımızda</h2>
              <h3>İnsan Kaynağınızın Gizli Kodlarını Açığa Çıkarın</h3>
              <p>
                Quders Q-Test, Enneagram temelli bir kişilik analizi platformudur. Kurumların
                insan kaynağını yalnızca yetkinlikleriyle değil, kişilik dinamikleriyle de
                tanımasını sağlar. Böylece iletişimden liderliğe, ekip yapılarından performans
                yönetimine kadar pek çok alanda daha isabetli kararlar alınabilir.
              </p>
              <p>
                <strong>Bu bir sınav değildir.</strong> Quders Q-Test, doğru ya da yanlış cevaplar
                aramaz. Her çalışan için kişiliğe özgü eğilimleri, içsel motivasyonları ve
                davranış kalıplarını analiz eder. Hedefi, hem bireysel farkındalık oluşturmak hem
                de kurumların çalışanlarına dair stratejik içgörüler geliştirmesine destek
                olmaktır.
              </p>

              <h3>Danışmanlıklarımız</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>
                      <strong>Ekip Yapıları</strong>, kişilik tiplerinin iletişim tarzları, stres tepkileri ve
                      motivasyon kaynakları dikkate alınarak daha uyumlu şekilde yapılandırılır.
                    </li>
                    <li>
                      <strong>Liderlik gelişimi</strong>, bireyin doğal liderlik yaklaşımı ve potansiyel zorluk
                      alanlarına göre kişiselleştirilir.
                    </li>
                    <li>
                      <strong>Geri bildirim süreçleri</strong>, bireylerin geribildirim alma biçimlerine göre
                      tasarlanır; yapıcı ve etkili bir gelişim zemini oluşturulur.
                    </li>
                    <li>
                      <strong>Mentorluk ve menti ilişkileri</strong>, kişilik uyumu doğrultusunda eşleştirilir;
                      gelişimi hızlandıran sağlıklı ilişkiler kurulur.
                    </li>
                    <li>
                      <strong>Performans hedefleri</strong>, çalışanın değer önceliklerine ve başarı anlayışına
                      uygun biçimde tanımlanır, hedeflerin içselleştirilmesi sağlanır.
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>
                      <strong>Öğrenme tarzları</strong>,temel alınarak bireyselleştirilmiş gelişim planları
                      oluşturulur; eğitim yatırımları daha verimli hale gelir.
                    </li>
                    <li>
                      <strong>Çatışma yönetimi ve iletişim</strong>, her tipin stres altındaki tepkileri ve çözüm
                      eğilimleri üzerinden şekillendirilerek ekip içi denge korunur.
                    </li>
                    <li>
                      <strong>Satış ve Müşteri ilişkileri</strong>, kişilik tipine özgü davranış kalıplarının
                      analiz edilmesiyle geliştirilir; etki alanı artırılır.
                    </li>
                    <li>
                      <strong>Çalışan bağlılığı ve içsel motivasyon</strong>, kişinin kendini tanıması ve kurumun
                      bunu anlaması ile kalıcı biçimde güçlenir.
                    </li>
                    <li>
                      <strong>Quders Q-Test</strong>, yalnızca sonuç veren bir test değil; uygulanabilir
                      stratejiler, ölçülebilir faydalar ve uzun vadeli gelişim olanakları sunan
                      bir çözüm ortağıdır.
                    </li>
                  </ul>
                </div>
              </div>

              <p style={{ marginTop: "20px", fontStyle: "italic" }}>
                Veriyi içgörüye, içgörüyü stratejiye dönüştüren kurumlar için <strong>Quders Q-Test</strong>,
                insan kaynağının potansiyelini açığa çıkarır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
